import {DynField} from '../../dyn-field';

export class DynTemporalField
    extends DynField {
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/temporal/dyn-temporal-field.ts